import React, { useContext, useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import { Backdrop, CircularProgress, Dialog, DialogTitle } from "@mui/material";
import { Button, Grid, Stack } from "@material-ui/core";
import { Save } from "@material-ui/icons";
import { Formik } from "formik/dist/index";
import BasicInputField from "../form/BasicInputField";
import { BrandContext } from "../../../contexts/BrandContext";
import { initialValues, getValidationFromFields } from "../form/FormUtilities";
import axios from "../../../utils/axios";
import { cWarn } from "../CustomLogger";


export default function ChangeProviderDialog(props){


    const {
        showDialogue,
        setShowDialogue,
        taxiId,
        onComplete
    } = props;

    const brandContext = useContext(BrandContext);
    const {textContent} = brandContext;
    
    const {
        changeProviderButton:dialogueTitle='',
        widget_saveButton:saveButton='',
        fileTypeErrorCSV=''

    } = textContent;

    const [providerOptions,setProviderOptions] = useState([]);
    const [processingBooking,setProcessingBooking] = useState(false);

    const formFields = {
        'selectProvider': {
            'label': 'selectFileLabel',
            'type':'select',
            'options':providerOptions
        },
    }

    useEffect(() => {
        if (providerOptions.length === 0) {
            const apiPath = `${process.env.REACT_APP_API_URL}/getavailablefpsfortb/${taxiId}`;
            axios.get(apiPath,{
                timeout: 300000,
                withCredentials:true
            }).then((res) => {
                const {
                    data:{
                        fpOptions=[]
                    }
                } = res;
                setProviderOptions(fpOptions);
            }).catch(err => {
                cWarn(err);
            });
        }
      }, []);

   

    return (
        <Dialog open={showDialogue} onClose={()=>{setShowDialogue(false)}} className="darkDialogue">
            <DialogTitle>{dialogueTitle}</DialogTitle>
            <Formik
                initialValues={initialValues(formFields)}
                validationSchema={getValidationFromFields(formFields)}
                onSubmit={(values)=>{
                    setProcessingBooking(true);
                    const apiPath = `${process.env.REACT_APP_API_URL}/changetaxibookingprovider/${taxiId}`;
                    axios.post(apiPath,values,{
                        timeout: 300000,
                        withCredentials:true
                    }).then((res) => {
                        console.log(res.data);
                        setProcessingBooking(false);
                        onComplete();
                    }).catch(err => {
                       cWarn(err);
                    });
                }}
            >
                {props => (
                    <Box p={3}>
                        <form onSubmit={props.handleSubmit}>
                        <Stack spacing={2}  alignItems="center">
                            
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12}>
                                        <BasicInputField 
                                            sx={{width:'100%'}}  
                                            formik={props} 
                                            formFields={formFields} 
                                            fieldName="selectProvider"
                                        />
                                    </Grid>
                                </Grid>
                            
                            <Button
                                className="bookingButton"
                                variant="outlined"
                                onClick={()=>{props.handleSubmit()}}
                                startIcon={<Save/>}
                            >
                                {saveButton}
                            </Button>
                        </Stack>
                        </form>
                    </Box>
                )}
            </Formik>
            {processingBooking &&
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open
                    >
                    <CircularProgress color="inherit" />
                </Backdrop>
            }
        </Dialog>
    );


}

